<template>
  <div>

    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.2
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

    <div class="seven3css">
      <SeventyThirtysection :LeftsideText="policytext1" :RightsideText="susthighlight" />
    </div>

      <div class="pdftable">
        <DownloadPdf :tabledata="corpgovernpolicy" :opssection1="policytext2"  />
      </div>

      <div>
        <SwiperSlide :SliderData="SliderData" :slidertextinfo="slidertext" swipertheme="swiperthemecss"/>
      </div>
<!-- 
      <div class="allreports">
        <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
        :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
        :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" 
        :bgimage="bgimage" :showbg="showbg"  :showrptfulltext="showrpttext"  />
      </div> -->
   

  </div>
</template>

<script>

import SwiperSlide from '@/components/SwiperSlide.vue';
import DataleftCardright from '@/components/DataleftCardright.vue';
import DownloadPdf from '@/components/DownloadPdf.vue';
import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
import AllReports from '@/components/AllReports.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
  SwiperSlide, DataleftCardright, DownloadPdf, SeventyThirtysection, AllReports
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  myPicUrl: '',

  corpgovernpolicy: [],
  policytext1: '',
  policytext2: '',
  slidertext: '',
  susthighlight: '',

  SliderData: [],
  bgimage: '',

  showrpttext: false,
  showbg: false,

  reportpresentation: [],
  lastrecordsreportpresent: [],
  }
},
methods: {

},
async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/policiesandcommitment').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
      console.log(error)
    })
   //------------corpgovernance info---------------
   await axios.get('getpolicyandcommitmentinfo/').then(
    response => {
        this.policytext1 = response.data[0].pctxt1
        this.policytext2 = response.data[0].pctxt2
        this.slidertext = response.data[0].pcslidertext
        
       
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })



   //------------corpgovernpolicy table info---------------
   await axios.get('getcorpgovernpolicyinfo/policiesandcommitment').then(
    response => {
        this.corpgovernpolicy = response.data
  })
  .catch((error) => {
      console.log(error)
    })
  //------------all highlights---------------
  await axios.get('getallhiglights/policiesandcommitment').then(
    response => {
        this.susthighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })
  
  //------------all sliders(generic)---------------
  await axios.get('getallslidersgeneric/policiesandcommitment').then(
    response => {
        this.SliderData = response.data
  })
  .catch((error) => {
      console.log(error)
    })

 
   //------------Get Reports---------------
   await axios.get('reportpresentationlisting/policiesandcommitment').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.bgimage =  response.data.bgimage
        console.log(this.bgimage)
        this.showrpttext = response.data.showrptfulltext
        this.showbg = response.data.showbgimage

      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })

  // //------------all sliders(generic)---------------
  // await axios.get('getbgimage/policiesandcommitment').then(
  //   response => {
  //       this.bgimage = this.myPicUrl + response.data[0].bgimageupload
  //       console.log(this.bgimage)
  // })
  // .catch((error) => {
  //     console.log(error)
  //   })
}
}
</script>

<style scoped>
.txtdata {
  text-align: left;
  background-color: #003;;
  margin-left: 0px;
  opacity: 0.7;
  margin-top: -100px;
 }
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.formatrow {
  margin-top: 340px;
  padding-left: 100px;
  padding-right: 100px;
}
.seven3css {
  margin-top: 100px;
}

.reportpresentcss {
  margin-top: 300px;
}
.allreports {
  margin-top: 120px;
}
.swiperthemecss {
  background-color: #003;;
}
.pdftable {
  padding-bottom: 100px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
/* Move the background and make it larger. 
/* Media Query CSS*/
@media only screen and (max-width: 600px) {
  .allreports {
    margin-top: 170px;
  }
 
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .allreports {
    margin-top: 170px;
  }
 
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
 
}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
 
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
 
  .allinnerwrapper {
    padding-left: 160px;
    padding-right: 160px;
  }

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
 

}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1600px) {

}
</style>
